/*
Dentist Edit Profile Form Component
================================================================================
*/

/*
Imports
------------------------------------------------------------
*/
// libs
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {
  Field,
  reduxForm
} from 'redux-form';

// app
import Input from 'components/Input';
import LabeledInput from 'components/LabeledInput';

// images deletion actions

// local
import styles from '../styles.module.css';
import validator from '../validator';

/*
Field Validators
------------------------------------------------------------
*/

/*
Edit Profile Form
================================================================================
*/

@reduxForm({
  form: 'out-of-network-tab1',
  enableReinitialize:true,
  validate: validator,
})
@CSSModules(styles, { allowMultiple: true })
export default class Tab1 extends React.Component {

  constructor (props) {
    super(props);
    this.submitRef = React.createRef();
  }


  /*
  Actions
  ------------------------------------------------------------
  */



  getInput(props) {
    return new Input(props);
  }

  getLabeledInput(props) {
    return new LabeledInput(props);
  }

  handleFormSubmit=(values)=>{
    this.props.changeMemberCount(values)
  }

  handleKeyDown = (e) => {
    if(e.key == "Enter") {
      e.preventDefault();
      this.submitRef.current.click()
    }
  }

  /*
  Render
  ------------------------------------------------------------
  */
  render() {
    const {
      handleSubmit,
      submitting
    } = this.props;

    return (
      <form className="form-horizontal">
        <div className="container" styleName="tab1">
            <div className="row" styleName="introtext">
                <p styleName="emphasis">
                  Dental insurance is a problem.
                </p>
                <p>
                Dropping a carrier is scary though, right? It doesn’t have to be - we got your back.
                </p>
                <p>
                Some patients will leave, and, well, that stinks...but it’ll be fine. Those that remain will be paying full fees.
                </p>
                <p>
                So how many of those remaining patients do you need to break even?<br/>Let’s find out...
                </p>
            </div>
            <div className="row" styleName="firstly">First, approximately how many patients do you have in this insurance network?
              <span>If you're not sure, just estimate</span>
            </div>
            <div 
              styleName="flex-container patientnum"  
              style={{width:'20%',margin:'0 auto'}} 
              onKeyDown={this.handleKeyDown.bind(this)}
            >
                <Field
                className="flex-center"
                name="memberCount"
                type="number"
                component={this.getInput}
                />
            </div>
            <div styleName="nextbutton">
              <a className="btn btn-primary" styleName="large-button--primary"  onClick={handleSubmit(this.handleFormSubmit)} ref={this.submitRef}>SHOW ME {">"}</a>
            </div>
          </div>
      </form>
    );
  }
}
